export interface State {
    list: any[];
}

export const state: State = {
    list: [],
};
